import {LOAD_EPISODE} from '../actions/episode';

const initialState = {
    episodes: undefined,
    episode: undefined,
};

export default function episodeReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_EPISODE:
            let newEpisode = action.payload.episode && {
                [action.payload.episode.id]: action.payload.episode,
            };
            return {
                ...state,
                loading: action.payload.loading,
                episode: {...state.episode, ...newEpisode},
            };

        default:
            return state;
    }
}
